// Integrations-Store für die Dashboard-Karte. Drei Kanäle heute:
// MQTT-Broker, zigbee2mqtt, zwavejs2mqtt. "Variante a" -- Health-
// Liste der Haus-Automatisierungs-Integrationen, keine Plattform-
// Registry. Wenn weitere Bridges dazukommen (Home Assistant Mesh,
// Frigate, ...) extendet sich der Backend-Endpoint, der Store nicht.
//
// Seit 02.11.2026 ohne eigenen Abruf und Takt: die Liste steht in netz.lage
// über das Homelab-Protokoll (docs/protokoll.md › „Netzwerk über das
// Protokoll“) im gemeinsamen Netz-Stand (netz.svelte.ts); REST nur beim Start.

import { getNetzIntegrationen, startNetz } from "./netz.svelte";

export interface Integration {
  id: string;
  name: string;
  // Bridge-Status: ist die Brücke (z2m, zwavejs2mqtt, mqtt-Broker)
  // selbst alive? Sagt nichts über die einzelnen Geräte dahinter.
  status: "ok" | "problem" | "loading" | string;
  detail: string;
  last_seen_unix: number;
  // Geräte-Aggregat: total/online über alle Geräte dieser Bridge.
  device_total: number;
  device_online: number;
  // Worst-of: kombiniert Bridge-Status + Geräte-Quote. Fürs
  // Dashboard-Roll-Up wichtig -- "Bridge ok, 1 Sensor offline"
  // soll dort als warning sichtbar werden.
  aggregate_status: "ok" | "warning" | "problem" | string;
}

let _off: (() => void) | undefined;

export function startIntegrations(): void {
  if (_off) return;
  _off = startNetz();
}

export function stopIntegrations(): void {
  _off?.();
  _off = undefined;
}

export function getIntegrations(): Integration[] | undefined {
  return getNetzIntegrationen();
}
